<template>
  <div 
    class="cartitem align-items-center" 
    :class="{
      'showtime_cartitem':theme=='showtime',
      'free-box':pro.wdr_free_product=='Free'
    }">
    <div class="item_info">
      <div class="pro_img">
        <a :href="pro.product.path||pro.product.public_url">
          <img
            :src="pro.variant?pro.variant.feature_image?pro.variant.feature_image.thumbnail:pro.product.feature_image?pro.product.feature_image.thumbnail:defaultImage:pro.product.feature_image?pro.product.feature_image.thumbnail:defaultImage"
            @error.once="imageFailure($event,defaultImage)"
            class="lazyload"
          />
        </a>
      </div>
      <div class="pro_title" :class="theme=='showtime'?'f_title_case':''">
        <h3 :style="theme=='showtime'?'font-size:14px':''">
          <a
            class="page_text_font"
            :href="pro.product.path||pro.product.public_url"
          >{{pro.product.post_title}}</a>
        </h3>
        <p v-if="pro.variant&&pro.variant&&pro.variant.attrs&&pro.variant.attrs.length">
          <span class="secondary_title" :style="theme=='showtime'?'font-size:12px':''" v-for="item in pro.variant.attrs" :key="item.name+item.value">{{item.value}}</span>
        </p>
        <template v-if="pro.properties">
          <template v-for="(subitem, subindex) in pro.properties">
          <p
            class="text-overflow-1"
            v-if="subitem"
            :key="subindex + subitem"
          >
            <span class="secondary_title" :style="theme=='showtime'?'font-size:12px':''">
              {{ subindex }} : 
              <template v-if="subitem.search(/^https?:\/\//)==-1">  {{ subitem }} </template>
              <a class="preview" v-else :href="subitem" @click.prevent="downloadFile(subitem,subitem)">Preview</a>
            </span>
          </p>
        </template>
        </template>
      </div>
    </div>
    <div class="free-item" v-if="pro.wdr_free_product=='Free'">
        <div class="free-label venue_sales_label">Giveaway</div>
        <div class="image-box">
          <a :href="pro.product.path||pro.product.public_url">
            <img
              :src="pro.variant?pro.variant.feature_image?pro.variant.feature_image.thumbnail:pro.product.feature_image?pro.product.feature_image.thumbnail:defaultImage:pro.product.feature_image?pro.product.feature_image.thumbnail:defaultImage"
              @error.once="imageFailure($event,defaultImage)"
              class="lazyload"
            />
          </a>
        </div>
        <div class="text-box">
          <h3 :style="theme=='showtime'?'font-size:14px':''">
            <a
              class="page_text_font text-item"
              :href="pro.product.path||pro.product.public_url"
            >{{pro.product.post_title}}</a>
          </h3>
          <p class="variant text-item" v-if="pro.variant&&pro.variant&&pro.variant.attrs&&pro.variant.attrs.length">
            <span class="secondary_title" v-for="item in pro.variant.attrs" :key="item.name+item.value">{{item.value}}</span>
          </p>
          <div id="discount_price">
            <v-selectprice
              :price="(pro.line_total/pro.quantity).toFixed(2)"
              :disable_select="true"
              :country="show_currency_selector ? $store.state.pricetype : ''"
              :fontSize="14"
            ></v-selectprice>
            <span>x {{pro.quantity}} </span>
          </div>
        </div>
    </div>
    <div class="item_num">
      <v-inputnum
        v-model="pro.quantity"
        @change="changequantity($event,pro.key,pro.product_id,pro.variation_id)"
        :min="0"
        :step="1"
        :disabled="disabled"
      ></v-inputnum>
    </div>
    <div class="item_price">
      <v-selectprice
        :price="pro.line_total.toFixed(2)"
        :font-size="16"
        :regular-font-size="14"
        :regular_price_wrap="true"
        :regular_price_num="pro.line_subtotal!=pro.line_total?pro.line_subtotal.toFixed(2):0"
        :disable_select="theme == 'showtime'?'true':!show_currency_selector"
        :country="theme == 'showtime'?!show_currency_selector?'':$store.state.pricetype:''"
        :appendToBody="false"
      ></v-selectprice>
      <div
        v-if="coupons.length && this.$store.state.news_cart && this.$store.state.news_cart.discount_cart>0 && pro.line_subtotal!=pro.line_total"
        class="secondary_title"
        style="font-size:14px;line-height:30px;word-break: break-word;"
      >{{popcart&&coupons[0].description?coupons[0].description:coupons[0].code}}</div>
    </div>
    <div class="closebtn" v-if="theme=='showtime'">
      <button
        type="button"
        class="close"
        :disabled="disabled"
        @click="clearall(pro.key,pro.product_id,pro.variation_id)"
      >
        <span aria-hidden="true" class="iconfont iconclose2"></span>
      </button>
    </div>
  </div>
</template>
<script>
import vInputnum from "@/views/venue/js/common/inputnum.vue";

export default {
  components:{
    vInputnum
  },
  props: [
    "product",
    "show_currency_selector",
    "coupons",
    "disabled",
    "popcart",
    "theme",
    "currency_style"
  ],
  data() {
    return {
      pro: this.product,
      // defaultImage
    };
  },
  watch: {
    product() {
      this.pro = this.product;
    }
  },
  methods: {
    changequantity(num, key, pro_id, var_id) {
      this.$emit("changequantity", num, key, pro_id, var_id);
    },
    clearall(key, pro_id, var_id) {
      this.changequantity(0, key, pro_id, var_id);
    }
  }
};
</script>
<style scoped lang='scss'>
.free-box {
  background: #fafafa;
  padding: 15px 0;
  text-transform: initial;
  position: relative;
  .item_info,.item_num,.item_price,.closebtn {
     display: none !important;
   }
   .free-item {
     width: 280px;
     min-height: 90px;
     margin-left: 15px;
     display: flex;
     align-content: center;
     background: #fff;
     .free-label {
      position: absolute;
      width: 70px;
      height: 20px;
      color:#fff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 3px;
      box-sizing: border-box;
      border-radius: 28px;
      z-index: 100; // 图片hover 标签被覆盖
      font-size: 9px;
     }
     .image-box {
        width: 90px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 15px;
        margin-left: 10px;
        padding: 10px 0;
        a {
          display: flex;
          align-items: center;
          width: 70px;
          height: 100%;
          img {
            width: 100%;
            height: auto;
          }
        }
     }
     .text-box{
       display: flex;
       align-items: baseline;
       flex-direction: column;
       justify-content: space-evenly;
       width: 100%;
       padding: 6px;
       p {
         margin-bottom: 0;
         font-size: 12px;
       }
       .variant {
          text-transform: lowercase;
          & > span:not(:last-child)::after {
            content: " / ";
          }
       }
       .text-item {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        text-overflow: -o-ellipsis-lastline;
       }
       #discount_price {
        font-size: 12px;
        color: #222222;
        &::v-deep {
          .product_price_price {
            .money {
              font-size: 12px !important;
              color: #222222 !important;
            }
          }
        }
      }
     }
  }
}
.showtime_cartitem {
  .item_info {
    width: 50% !important;
    .f_title_case {
      h3 a {
        color: unset;
      }
      p {
        color: #666666;
      }
      
    }
  }
  .item_price{
    width: 30% !important;
  }
  .closebtn {
    width: 5%;
  }
}
.cartitem {
  display: flex;
  align-content: center;
  margin-bottom: 16px;
  margin-left: -8px;
  a{
    color: inherit;
  }
  .item_info {
    width: 55%;
    display: flex;
    .pro_img {
      width: 25%;
      padding-left: 8px;
      max-width: 114px;
      a {
        width: 100%;
        height: auto;
        img {
          width: 100%;
        }
      }
    }
    .pro_title {
      width: 75%;
      padding-left: 10px;
      padding-right: 20px;
      h3 {
        color: #111;
        font-size: 14px;
        margin: 0;
        line-height: 22px;
        a {
          font-weight: 500px !important;
        }
      }
      p {
        font-size: 12px;
        margin: 0;
        margin-top: 8px;
        line-height: 22px;
        span:not(:last-child) {
          &::after {
            content: " / ";
          }
        }
      }
      .preview:hover {
        opacity: 0.7;
        cursor: pointer;
      }
    }
  }
  .item_num {
    width: 20%;
    padding-left: 8px;
  }
  .item_price {
    width: 20%;
    padding-left: 8px;
    text-align: right;
    color: #111;
    line-height: 18px;
    font-family: "Oswald", sans-serif;
    font-weight: 400;
    letter-spacing: 1px;
  }
}

@media screen and(max-width: 768px) {
  .showtime_cartitem {
    .item_info {
      width: 100% !important;
    }
    .item_num {
      width: 50% !important;
    }
    .item_price {
      width: 50% !important;
      text-align: right;
    }
      .closebtn {
      display: none;
    }
  }

  .cartitem {
    flex-wrap: wrap;
    .item_info {
      width: 100%;
      .pro_img {
        width: 33.33%;
      }
      .pro_title {
        width: 66.66%;
        padding-right: 0px;
        h3 {
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
    .item_num {
      width: 45%;
      padding-top: 12px;
    }
    .item_price {
      width: 55%;
    }
  }
}
</style>